<template>
    <v-dialog v-model="exibirModal" :max-width="Modal.Confirmacao.larguraMaxima" persistent>
    <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
        <v-card-title class="primary modal-title" primary-title>
            <span>Cancelar envio de protocolo</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('fechar')">
                <v-icon color="white">close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text class="cancelar-protocolo__texto">
            <p class="mb-0">
                Deseja realmente cancelar o protocolo:<br>
                <strong>{{ numeroProtocolo }}</strong>?
            </p>
        </v-card-text>
        <v-card-actions class="px-3 py-2">
            <v-btn id="botaoFechar"
                               @click="$emit('fechar')"
                               color="botao-cancelar-color" flat outline>
                Não
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn id="botaoCancelar"
                               @click="$emit('cancelarProtocolo')"
                               color="primary" depressed>
                Sim
            </v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'ProtocoloModalCancelar',
    props: ['exibirModal', 'numeroProtocolo'],
    data() {
        return {
            Modal
        }
    }
}
</script>

<style scoped lang="stylus">
    .cancelar-protocolo
        &__texto
            text-align center
            color #777

        &__acao
            text-align center
            margin-bottom 16px

            .botao
                color #777 !important
                border 0

            .botao:first-child
                margin-right 10px

            .botao-primario, .botao
                text-transform uppercase
                font-size 13px

            .botao-primario
                background-color var(--v-primary-base) !important
                color #fff !important
                border 1px solid var(--v-primary-base) !important
</style>